import { PlayerModel } from '@modules/player/player-model';

const fields = new PlayerModel().fields();

export default [
  fields.id,
  fields.firstName,
  fields.lastName,
  fields.birthdate,
  fields.country,
  fields.gender,
  fields.createdAt
];
